<template>
  <AppLayout>
    <v-container grid-list-md fluid pa-0 class="leases">
      <v-layout justify-center row wrap>
        <v-expansion-panel class="elevation-0 lg9">
          <v-expansion-panel-content v-for="group in endingLeaseGroups" :key="group.label">
          <template v-slot:header>
            <span class='panel-header'>
              <v-icon :class="group.classes">alarm</v-icon>
              <span style="padding-left: 1rem;">{{group.label}}</span>
              <v-chip class="end-of" small color="primary" text-color="white">
                {{group.leases.length}}
              </v-chip>
            </span>
          </template>
          <v-flex>
              <v-list v-if="group.leases.length > 0" subheader>
                <template v-for="lease in group.leases">
                  <v-list-tile
                    :key="lease.id"
                    class="lease"
                    @click="displaySelectedLease(group, lease)"
                  >
                    <v-list-tile-avatar class="avatar">
                      <v-icon :class="group.classes">alarm</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>
                        {{lease.showStreetAddress}}
                      </v-list-tile-title>
                      <v-list-tile-sub-title>
                        {{lease.showRegion}}
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <div style="display:flex" class="chips-container">
                        <v-chip small :class="group.classes">
                         {{ lease.checkout_date }}
                        </v-chip>
                        <v-chip small :class="group.classes">
                         {{ lease.leftDays }}
                        </v-chip>
                      </div>
                    </v-list-tile-action>
                  </v-list-tile>
                </template>
              </v-list>
          </v-flex>
        </v-expansion-panel-content>

      </v-expansion-panel>

      </v-layout>
    </v-container>
    <LeaseTaskDialog ref="dlg"/>
  </AppLayout>
</template>

<script>
import AppLayout from '@/views/AppLayout'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import moment from 'moment'
import LeaseStatus from '@/helpers/lease_status';
import LeaseTaskDialog from '@/components/leases/LeaseTaskDialog'

export default {
  name: 'Leases',
  components: {
    AppLayout,
    LeaseTaskDialog,
  },
  data() {
    return {
      searchTerm: null,
      selectedSorting: null,
      showLeaseTaskDialog: false,
      fetchLeaseListCalled: false,
    }
  },
  computed: {
    ...mapGetters({
      leases: 'LeaseList/getAll',
      selectedLease: 'LeaseList/getSelectedLease',
      getHouseList: 'HouseList/getHouseList',
    }),
    endingLeases() {
      return this.leases
      .map(lease => {
        const house = this.findHouse(lease)
        console.log('findHouse: ', house)
        return ({
          ...lease,
          leftDays: this.leftDays(lease),
          showStreetAddress: this.showStreetAddress(house),
          showRegion: this.showRegion(house),
        })
      })
    },

    endingLeaseGroups() {
      const leaseGroup = [{
        label: 'Renewal Refused',
        classes: 'confirming-rerent',
        leases: this.endingLeases.filter(lease => lease.status === LeaseStatus.RenewalRefused)
      }, {
        label: 'Confirming renewal',
        classes: 'confirming-rerent',
        leases: this.endingLeases.filter(lease => lease.status === LeaseStatus.RenewalConfirming)
      }, {
        status: LeaseStatus.RenewalInviting,
        label: 'Renewal Inviting',
        classes: 'confirming-rerent',
        leases: this.endingLeases.filter(lease => lease.status === LeaseStatus.RenewalInviting)
      }, {
        status: LeaseStatus.Running,
        label: 'Waiting list',
        classes: 'waiting-list',
        leases: this.endingLeases.filter(lease => lease.status === LeaseStatus.Running && this.leftDays(lease) <= 90)
      }, {
        status: LeaseStatus.Running,
        label: 'More...',
        classes: 'reminding-list',
        leases: this.endingLeases.filter(lease => lease.status === LeaseStatus.Running && this.leftDays(lease) >= 90 && this.leftDays(lease) <= 120)
      }, {
        status: LeaseStatus.Confirming,
        label: 'Confirming contract',
        classes: 'confirming-rerent',
        leases: this.endingLeases.filter(lease => lease.status === LeaseStatus.Confirming)
      }];
      // console.log('leaseGroup', leaseGroup)
      return leaseGroup;
    }
  },
  async mounted() {
    // onsole.log('mounted')
    if (!this.fetchLeaseListCalled) {
      this.fetchLeaseListCalled = true;
      await this.fetchLeaseList()
    }
  },
  methods: {
    ...mapActions({
      fetchLeaseList: 'LeaseList/fetch',
    }),
    ...mapMutations({
      selectLease: 'LeaseList/setSelectedLease',
    }),
    leaseCheckoutStatus(lease) {
      const status = lease.status;
      switch(status) {
      case 2:
        return (this.leftDays(lease) < 90) ? 'waiting-list': '';
      case 3:
        return 'reminding-rerent';
      case 4:
        return 'confirming-rerent';
      case 5:
        return 'confirming-checkout';
      case 8:
        return 'checking-out';
      default:
        return ''
      }
    },
    leftDays(lease) {
      const now = moment();
      const leaseCheckoutDate = moment(lease.checkout_date, 'YYYY-MM-DD');
      const days = leaseCheckoutDate.diff(now, 'days')
      return days;
    },
    showStreetAddress(house) {
      if (!house) {
        return 'Unknown address'
      }
      const { unit, num, street } = house
      return unit? [[unit, num].join('/'), street].join(' '): [num, street].join(' ')
    },
    showRegion(house) {
      if (!house) {
        return 'Unknown'
      }
      const { suburb, city } = house
      return [suburb, city].join(', ')
    },
    async displaySelectedLease(group, lease) {
      lease.group = group;
      this.selectLease(lease);
      await this.$refs.dlg.open()
    },
    findHouse(lease) {
      let house = lease.house
      return house
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~vuetify/src/stylus/settings/_colors';

.v-list__tile--selected {
  border-left: 5px solid #2484C6;
  background-color: $grey.lighten-3;
}

.leases {
  position: relative;

  &__list .v-list {
    max-height: 80vh;
    overflow-y: scroll;

    > div {
      border-bottom: 1px solid $grey.lighten-2;
    }
  }

  &__list--selected {
    position: sticky;
    top: 80px;
    max-height: 690px;
    padding-right: 20px !important;

    .v-list {
      max-height: 600px;
    }
  }
}

.chips-container {
  .checking-out {
    background: orange;
  }
  .confirming-rerent {
    background: lightgreen;
  }
  .reminding-rerent {
    background: lightblue;
  }
}

.avatar, .panel-header {
  .checking-out {
    color: orange;
  }
  .confirming-rerent {
    color: green;
  }
  .reminding-rerent {
    color: blue;
  }
}

.panel-header {
  padding:4px;
  width: 100%;
  display: flex;
}

.end-of {
  margin-left: auto;
}

.v-chip__content {
  width: 100%;
}

.lease:hover {
  background-color : lightgray;
  border-radius: 5px;
}

</style>
